import _ from 'lodash';

const limit = 65;
const allAges = (rate) => {
  let ages = { age_0_14: !_.isEmpty(rate) ? rate['age_0'] : '' };

  for (let i = 15; i <= limit; i++) {
    ages = {
      ...ages,
      [`age_${i}`]: !_.isEmpty(rate) ? rate[`age_${i}`] : '',
    };
  }

  return ages;
};

let ALL_AGES_NAMES = {
  age_0_14: 'Age 0-14',
};

for (let i = 15; i <= limit; i++) {
  ALL_AGES_NAMES = {
    ...ALL_AGES_NAMES,
    [`age_${i}`]: `Age ${i}`,
  };
}

export const normalizeAllAgeRates = (allAgeBandedRates) => {
  let payload = {
    ...allAgeBandedRates,
  };

  for (let i = 0; i <= 14; i++) {
    payload = {
      ...payload,
      [`age_${i}`]: allAgeBandedRates['age_0_14'],
    };
  }

  delete payload['age_0_14'];

  return payload;
};

export { allAges, ALL_AGES_NAMES };
